import React from "react";
import {
    faEdit,
    faToggleOn,
    faToggleOff,
    faEye
} from "@fortawesome/free-solid-svg-icons";
import styled from "styled-components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    cuadroRequerimientosActivarInactivarCampanaAPI,
} from "../../../../consumers/backendApisUrls";
import {useManagePostRequest} from "../../../../hooks/useManagePostRequest/useManagePostRequest";
import EditarCampana from "../crearEditar/EditarCampana";

const Card = styled.div`
    border: 1px solid ${({ selected }) => (selected ? "#007bff" : "#ddd")};
    background-color: ${({ selected }) =>
            selected ? "#eaf3ff" : "#fff"};
    padding: 12px;
    margin-bottom: 10px;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.2s;

    &:hover {
        background-color: ${({ selected }) =>
                selected ? "#eaf3ff" : "#f7f9fc"};
    }
`;

const CardHeader = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
`;

const Title = styled.div`
    font-weight: 600;
    font-size: 13px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const ActionIcon = styled(FontAwesomeIcon)`
  cursor: pointer;
  transition: transform 0.12s ease, opacity 0.12s ease;

  &:hover {
    opacity: 0.8;
    transform: scale(1.1);
  }
`;

const Text = styled.div`
  font-size: 12px;
  color: #555;
`;

export default function CampanaCard({ campana, isSelected, onClick,refreshListarCampanas, setModalEnabled }) {
    const [executePost] = useManagePostRequest();

    const handleActivarInactivar = async () => {
        const api = cuadroRequerimientosActivarInactivarCampanaAPI(campana.IdCampana);
        await executePost(api, {}, successCallback, true);
    }

    const successCallback = async () => {
        await refreshListarCampanas();
    }
    return (
        <Card onClick={onClick} selected={isSelected}>
            <CardHeader>
                <Title>{campana.Nombre}</Title>

                <Actions onClick={e => e.stopPropagation()}>
                    {campana.PuedeEditar && (
                        <ActionIcon
                            icon={faEdit}
                            size="sm"
                            title="Editar"
                            onClick={() =>
                                setModalEnabled({
                                    isEnable: true,
                                    component: EditarCampana,
                                    data: {idCampana: campana.IdCampana, isEditable: true}
                                })


                            }
                        />
                    )}

                    {campana.PuedeActivarInactivar && !campana.EsActivo && (
                        <ActionIcon
                            icon={faToggleOff}
                            size="sm"
                            title="Activar"
                            style={{ color: "#eb5757" }}
                            onClick={handleActivarInactivar}
                        />
                    )}

                    {campana.PuedeActivarInactivar && campana.EsActivo && (
                        <ActionIcon
                            icon={faToggleOn}
                            size="sm"
                            title="Inactivar"
                            style={{ color: "#27ae60" }}
                            onClick={handleActivarInactivar}
                        />
                    )}
                    {campana.PuedeEditar === false &&
                        <ActionIcon
                            icon={faEye}
                            size="sm"
                            title="Detalle"
                            onClick={() =>
                                setModalEnabled({
                                    isEnable: true,
                                    component: EditarCampana,
                                    data: {idCampana: campana.IdCampana, isEditable: false}
                                })
                            }
                        />
                    }

                </Actions>
            </CardHeader>

            <Text>Proceso: {campana.EstadoProceso}</Text>
            <Text>Registro: {campana.EstadoRegistro}</Text>
            <Text>
                Vigencia: {campana.FechaInicio} - {campana.FechaFin}
            </Text>
        </Card>
    );
}
